
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showFloatComponents: false,
      displayHover: false,
      isOpenSocialShare: false,
      socialNetworks: ['facebook', 'twitter', 'whatsapp', 'linkedin'],
    }
  },
  computed: {
    ...mapGetters({
      socialShare: 'float/socialShare',
      floatHelp: 'float/floatHelp',
      layoutData: 'layoutData',
    }),
    floatingButtons() {
      return this.$store.state.layoutData?.content?.floating_buttons?.buttons
    },
  },
  mounted() {
    const floatComponentsElement = this.$refs['float-components']

    document.body.addEventListener('click', (event) => {
      // Chequea si el click fue fuera de este componente
      if (
        !(
          floatComponentsElement === event.target ||
          floatComponentsElement.contains(event.target)
        )
      ) {
        this.displayHover = false
        this.isOpenSocialShare = false
      }
    })

    document.addEventListener('scroll', this.handleShowFloatComponents)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleShowFloatComponents)
  },
  methods: {
    toggleSocialShare() {
      this.isOpenSocialShare = !this.isOpenSocialShare
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.$showModalDialog('', this.$t('copyTextModal.success'), 'success')
        },
        () => {
          this.$showModalDialog('', this.$t('copyTextModal.error'), 'error')
        }
      )
    },
    handleShowFloatComponents() {
      this.showFloatComponents = true
    },
  },
}
